module.exports = __webpack_public_path__ + "img/right2.4393197f.png";